var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.host},[_c('v-btn',{staticClass:"unr-button",attrs:{"color":"primary"},on:{"click":_vm.setRegistrationStep}},[_vm._v(" New User Registration ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }